import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-full h-[500px] bg-gray-800 rounded-lg overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center h-full text-gray-400"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-lg" }, "Aucune station géolocalisée"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm mt-2" }, "Ajoutez la latitude et longitude aux stations pour les voir sur la carte")
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "w-full h-full"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "absolute bottom-4 left-4 bg-gray-900 bg-opacity-80 rounded-lg p-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-white font-semibold mb-1" }, "Stations :", -1)
const _hoisted_9 = { class: "text-xs text-gray-300 space-y-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "w-2 h-2 bg-green-500 rounded-full" }, null, -1)

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TravelRouteMap',
  props: {
    stations: {}
  },
  setup(__props: any) {

const props = __props;

const geoStations = ref(props.stations?.filter(s => s.latitude && s.longitude) || []);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (geoStations.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (geoStations.value.length > 0)
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 0,
                src: `https://www.openstreetmap.org/export/embed.html?bbox=${Math.min(...geoStations.value.map(s => s.longitude!)) - 0.5},${Math.min(...geoStations.value.map(s => s.latitude!)) - 0.5},${Math.max(...geoStations.value.map(s => s.longitude!)) + 0.5},${Math.max(...geoStations.value.map(s => s.latitude!)) + 0.5}&layer=mapnik`,
                class: "w-full h-full border-0",
                loading: "lazy"
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(geoStations.value, (station) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: station.id,
                  class: "flex items-center space-x-2"
                }, [
                  _hoisted_10,
                  _createElementVNode("span", null, _toDisplayString(station.station_name) + " (" + _toDisplayString(station.latitude) + ", " + _toDisplayString(station.longitude) + ")", 1)
                ]))
              }), 128))
            ])
          ])
        ]))
  ]))
}
}

})